// src/components/Common/CountrySelector.jsx
import React from 'react';
import { Input } from 'reactstrap';
import { COUNTRIES_CATALOG, suggestCountryDefaults } from '../../helpers/currencyHelper';

const CountrySelector = ({
  value,
  onChange,
  onCountrySelect,
  className = '',
  id = 'country-selector',
  name = 'country_code',
  disabled = false,
}) => {
  const handleChange = (e) => {
    const selectedCode = e.target.value;
    if (onChange) onChange(e);
    if (onCountrySelect) {
      const defaults = suggestCountryDefaults(selectedCode);
      onCountrySelect(defaults);
    }
  };

  return (
    <Input
      type="select"
      id={id}
      name={name}
      value={value || 'IN'}
      onChange={handleChange}
      className={className}
      disabled={disabled}
    >
      {COUNTRIES_CATALOG.map((c) => (
        <option key={c.code} value={c.code}>
          {c.flag} {c.name} ({c.default_currency} • {c.default_timezone})
        </option>
      ))}
    </Input>
  );
};

export default CountrySelector;
